import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedTenant({ children, requireAdmin = false }) {
  const { user, tenant } = useAuth();
  const { slug } = useParams();
  if (user === undefined) return <div className="p-10 text-stone-500">読み込み中...</div>;
  if (!user) return <Navigate to={`/t/${slug}/login`} replace />;
  // Super admin who navigates to a tenant URL: keep them out, send to super dashboard
  if (user.role === "super_admin") return <Navigate to="/super/dashboard" replace />;
  // Logged in as a different tenant — send them to their own tenant home
  if (tenant && tenant.slug !== slug) return <Navigate to={`/t/${tenant.slug}/`} replace />;
  if (requireAdmin && user.role !== "tenant_admin") return <Navigate to={`/t/${slug}/`} replace />;
  return children;
}

export function ProtectedSuper({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="p-10 text-stone-500">読み込み中...</div>;
  if (!user) return <Navigate to="/super/login" replace />;
  if (user.role !== "super_admin") {
    // if impersonating, allow access? No — operator dashboard requires super_admin role
    return <Navigate to="/" replace />;
  }
  return children;
}
